import httpClient from './httpClient'
import AuthMiddleware from '@/middlewares/authMiddleware'

class AuthAPI {
  static async loginApi(params) {
    const response = await httpClient.post('/auth/login', params)
    return response.data
  }

  static async login(params) {
    try {
      const response = await this.loginApi(params)
      const token = response.item.token
      AuthMiddleware.login(token)
      return response
    } catch (e) {
      throw e
    }
  }

  static async logoutApi() {
    await httpClient.post('/auth/logout')
  }

  static async logout() {
    if (AuthMiddleware.isLoggedIn()) {
      /** ログインしている場合のみ、リクエストを投げる */
      try {
        await this.logoutApi()
        AuthMiddleware.logout()
      } catch (e) {
        throw e
      }
    }
  }
}

export default AuthAPI
